'use strict';

window.jQuery = window.$ = require('jquery');
window.Swiper = require('swiper8/swiper-bundle');

const processInclude = require('base/util');

$(document).ready(function () {
  processInclude(require('./components/breadcrumbs'));
  processInclude(require('./components/tabs'));
  processInclude(require('./search'));
  processInclude(require('./search-filters'));
  processInclude(require('./cart'));
});
